import axios from 'axios';

const baseURL='http://localhost:3001/api/v1'
const storedUser = localStorage.getItem("user");
const storedUserData = storedUser?JSON.parse(storedUser):{accessToken:""}

const fetchNewAccessToken = async () => {
    try {
        const response = await axios.get(`${baseURL}/user/token/refresh`, {
            withCredentials: true 
          });
        const accessToken = response.data.elements;
        console.log(accessToken)
        localStorage.setItem('user', JSON.stringify(accessToken));
    } catch (error) {
        console.error('Failed to refresh token:', error);
    }
};

export const axiosClient = axios.create({
    baseURL: baseURL,
    headers: {
        "Content-Type": "application/json"
    },
    withCredentials: true,
});


export const axiosClientWithToken = axios.create({
    baseURL: baseURL,
    headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${storedUserData.accessToken}`
    },
    withCredentials: true,
});

axiosClientWithToken.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        if (error.response.status === 403 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                await fetchNewAccessToken();
                originalRequest.headers['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`;
                window.location.reload();
                return axios(originalRequest);
            } catch (err) {
                console.error('Token refresh failed:', err);
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);